import { Button, Card, Flex, Layout, Table, TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import { get, isEmpty, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import {
  handleExportExcelFuncNew,
  reDataForTable,
  renderTrangThai
} from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";
import { FileExcelOutlined } from "@ant-design/icons";
import ReactDOMServer from "react-dom/server";
import ChiTietTheoNguoiNhapTable from "./ChiTietTheoNguoiNhapTable";

const ChiTietTheoNguoiNhap = ({ status }: any) => {
  const { isActive } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();
  const { idnguoidang } = useParams();
  const [isLoadExcel, setIsLoadExcel] = useState<boolean>(false);

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (e) => <span>{e}</span>
    },
    {
      title: "Tên tài liệu",
      dataIndex: "tenTuLieu",
      key: "tenTuLieu"
    },
    {
      title: "Nhóm tài liệu",
      dataIndex: "nhomTuLieu",
      key: "nhomTuLieu",
      width: "25%",
      render: (item) => <span>{item.tenNhomTuLieu}</span>
    },
    {
      title: "Người đăng",
      dataIndex: "tenNguoiDang",
      key: "tenNguoiDang",
      width: "15%"
    },
    {
      title: "Tên tác giả",
      dataIndex: "tacGia",
      key: "tacGia",
      width: "15%"
    },
    {
      title: "Trạng thái",
      dataIndex: "trangThai",
      key: "trangThai",
      width: "15%",
      render: (item) => renderTrangThai(item)
    }
  ];

  useEffect(() => {
    if (isActive) {
      getListDataInfo(activePage);
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken([
        "listNguoiDung",
        "listloaitulieus",
        "listLoaiTaiLieu",
        "editTrangThai"
      ]);
    };
  }, []);

  /**
   * getListData: danh sách nhóm báo cáo
   * @param {number} activePage
   * @param {number} idNhomTuLieu
   * @param {string} keyword
   * @memberof QuanLyLoaiBaoCao
   */
  const getListDataInfo = async (activePage: number) => {
    setIsLoadTable(true);

    const configAPI = {
      url: `api/tulieus/nguoidang?page=${activePage}&size=${pageSize}&properties_sort=id&type_sort=desc&idnguoidang=${idnguoidang}`,
      method: "GET",
      value: "",
      apiType: "DETAIL",
      getName: "infoChucVu"
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setIsLoadTable(false);
        setTotal(get(response.data, "totalElements", 0));
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } catch (error) {
      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * handleTableChange: Fetch dữ liệu dựa theo thay đổi trang
   * @param {object} pagination
   * @memberof LoaiTaiLieu
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListDataInfo(activePage);
    setActivePage(activePage);
  };

  const handleXuatExcel = async () => {
    setIsLoadExcel(true);
    const configAPI = {
      url: `api/tulieus/nguoidang?page=0&properties_sort=id&type_sort=desc&idnguoidang=${idnguoidang}`,
      method: "GET",
      value: "",
      apiType: "DETAIL",
      getName: "infoChucVu"
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        if (!isEmpty(response.data.content)) {
          const HTMLTable = await ReactDOMServer.renderToStaticMarkup(
            <ChiTietTheoNguoiNhapTable dataTable={response.data.content} />
          );
          handleExportExcelFuncNew(HTMLTable, "THONG_KE_TONG_HOP_CHI_TIET");
        }
        setIsLoadExcel(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadExcel(false);
      }
    } catch (error) {
      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>
          Chi tiết theo người nhập
        </h3>
        <Button
          type="primary"
          style={{ marginLeft: "10px", background: "green" }}
          onClick={handleXuatExcel}
          loading={isLoadExcel}
        >
        {isLoadExcel ? "" : <FileExcelOutlined />} Xuất excel
        </Button>
      </Flex>
      <Card>
        <Table
          rowKey={"id"}
          bordered
          columns={columns}
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
          scroll={{ x: 800 }}
        />
      </Card>
    </Layout>
  );
};
export default ChiTietTheoNguoiNhap;
